// Importing necessary modules
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux"; // Import Provider from react-redux
import { EditableContentProvider } from "./Context/EditableContentContext.js";
import { router } from "./Route/Route.js";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd"
import { trackPageView } from "./utils/metaPixel.js";

import "./index.css";
import "./components/Shared/TranslateWidget/TranslateWidget.css";
import reportWebVitals from "./reportWebVitals";
import store from "./store.js"; // Import the Redux store

// Load saved language preference and set Google Translate cookie before script loads
const savedLang = localStorage.getItem("preferredLanguage");
if (savedLang) {
  const val = `/en/${savedLang}`;
  document.cookie = `googtrans=${val}; path=/`;
  document.cookie = `googtrans=${val}; path=/; domain=${window.location.hostname}`;
}

// Reveal the app (called after translation is applied or on timeout)
function revealApp() {
  const rootEl = document.getElementById("root");
  if (rootEl) rootEl.style.visibility = "visible";
}

// Programmatically trigger Google Translate to switch to the saved language
function applyTranslation(langCode) {
  let attempts = 0;
  const maxAttempts = 40; // 40 * 100ms = 4s max
  const interval = setInterval(() => {
    attempts++;
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = langCode;
      combo.dispatchEvent(new Event("change"));
      // Wait a bit for translation to render, then reveal
      setTimeout(revealApp, 300);
      clearInterval(interval);
    } else if (attempts >= maxAttempts) {
      // Give up waiting, reveal anyway
      revealApp();
      clearInterval(interval);
    }
  }, 100);
}

// Load Google Translate script globally
window.googleTranslateElementInit = function () {
  new window.google.translate.TranslateElement(
    {
      pageLanguage: "en",
      includedLanguages: "de,es,fr,ar,en,it,ur,zh-CN,ja,ru,ms,th,ko,hi,fa",
      layout: 0,
      autoDisplay: false,
    },
    "google_translate_element"
  );

  if (savedLang) {
    applyTranslation(savedLang);
  }
};
const gtScript = document.createElement("script");
gtScript.src =
  "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
gtScript.async = true;
document.head.appendChild(gtScript);

// Connecting to the root element in the index.html file
const root = ReactDOM.createRoot(document.getElementById("root"));

const originalPushState = window.history.pushState;
window.history.pushState = function () {
  originalPushState.apply(this, arguments);
  setTimeout(() => {
    trackPageView();
  }, 0);
};

window.addEventListener("popstate", () => {

  trackPageView();

});

// Pushing the Dashboard component to the root element which is the "ID Root" div in the index.html file
root.render(
  //<React.StrictMode>
    <Provider store={store}> {/* Wrap with Provider and pass the store */}
    <DndProvider backend={HTML5Backend}>
      <EditableContentProvider>
        {/* ====================================== Developer comment this code. */}
        <RouterProvider router={router} />
        {/* ========================== Created a Route.js and import it here. */}
      </EditableContentProvider>
    </DndProvider>
    </Provider>
  //</React.StrictMode>
);

// Calling the function to measure and report web performance metrics
reportWebVitals();
